// User model
export class User {
  constructor({
    id = "",
    email = "",
    firebaseUid = "",
    role = "",
    name = "",
    lastName = "",
    dni = "",
    phone = "",
    address = "",
    postalCode = "",
    city = "",
    country = "",
    birthdate = "",
    nationality = "",
    gender = "",
    sobreMi = "",
  }) {
    this.id = id;
    this.email = email;
    this.firebaseUid = firebaseUid;
    this.role = role;
    this.name = name;
    this.lastName = lastName;
    this.dni = dni;
    this.phone = phone;
    this.address = address;
    this.postalCode = postalCode;
    this.city = city;
    this.country = country;
    this.birthdate = birthdate;
    this.nationality = nationality;
    this.gender = gender;
    this.sobreMi = sobreMi;
  }

  static fromJson(json) {
    return new User({
      id: json.id || "",
      email: json.email || "",
      firebaseUid: json.firebaseUid || "",
      role: json.role || "",
      name: json.name || "",
      lastName: json.lastName || "",
      dni: json.dni || "",
      phone: json.phone || "",
      address: json.address || "",
      postalCode: json.postalCode || "",
      city: json.city || "",
      country: json.country || "",
      birthdate: json.birthdate || "",
      nationality: json.nationality || "",
      gender: json.gender || "",
      sobreMi: json.sobreMi || "",
    });
  }

  toJson() {
    return {
      id: this.id,
      email: this.email,
      firebaseUid: this.firebaseUid,
      role: this.role,
      name: this.name,
      lastName: this.lastName,
      dni: this.dni,
      phone: this.phone,
      address: this.address,
      postalCode: this.postalCode,
      city: this.city,
      country: this.country,
      birthdate: this.birthdate,
      nationality: this.nationality,
      gender: this.gender,
      sobreMi: this.sobreMi,
    };
  }
}
